<script setup>
import { ref } from "vue";

import InputField from "@/components/forms/InputField.vue";
import ButtonComponent from "@/components/Button/ButtonComponent.vue";
import { post } from "@/libs/axios.js";

const password = ref("");
const passwordError = ref("");

async function updatePassword() {
    const code = window.location.pathname.replace("/password-reset/", "");
    const url = "/ajax/new-password-request";
    const res = await post(url, {
        password: password.value,
        userUuid: window.userId,
        code,
    });
    if (res.data.success) {
        let getParams = "";
        if (res.data.url.includes("/business")) {
            getParams = "#show-banner=show";
        }

        window.onbeforeunload = null;
        window.location.href = res.data.url + getParams;
    } else if (res.data?.errors?.password?.length > 0) {
        passwordError.value = res.data.errors.password.join(", ");
    }
}
</script>

<template>
    <div @keyup.enter="updatePassword" class="d-flex flex-column col-4 mx-auto">
        <h2 class="mt-5">Update password</h2>

        <div class="info-text mb-5">Choose a new password.</div>

        <div class="d-flex flex-column position-relative">
            <InputField
                labelText="Password"
                placeholder="Enter new password"
                type="password"
                :maxlength="255"
                :required="true"
                v-model="password"
                :value="password"
                :error="passwordError"
                :testId="'new-email-input'"
            />
        </div>

        <div class="input-info-text">
            Passwords need at least 8 characters, a lower and uppercase letter,
            a number and a special character.
        </div>

        <div class="mt-5">
            <ButtonComponent
                @click="updatePassword"
                type="primary"
                class="ml-auto"
            >
                Update password
            </ButtonComponent>
        </div>
    </div>
</template>

<style scoped>
.info-text {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.3125rem;
    color: #636066;
}

.input-info-text {
    font-family: "Poppins";
    font-style: italic;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.3125rem;
    color: #636066;
}
</style>
